import { render, staticRenderFns } from "./DedicationCommunications.vue?vue&type=template&id=09a8668a&"
import script from "./DedicationCommunications.vue?vue&type=script&lang=js&"
export * from "./DedicationCommunications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports